// shared/pdf/themes.js

const _colored = {
  statusGreen:  '#059669',
  statusRed:    '#DC2626',
  statusAmber:  '#D97706',
  borderMid:    '#94A3B8',
  borderLight:  '#CBD5E1',
  borderDark:   '#334155',
  rowAlt:       '#F9FAFB',
  sectionBg:    '#F8FAFC',
  subtotalBg:   '#F1F5F9',
  totalBg:      '#EFF6FF',
  textSub:      '#475569',
  textTertiary: '#64748B',
  textFaint:    '#9CA3AF',
};

const PDF_THEMES = {
  saffron:  { primary: '#E07828', grad: '#F4A44A', dark: '#7C3D0A', light: '#FDF3E7', mid: '#F9D4A0', white: '#FFFFFF', body: '#374151', muted: '#8B929A', headerText: '#FFFFFF', titleText: '#E07828', rule: null, ..._colored },
  navy:     { primary: '#1565C0', grad: '#1E88E5', dark: '#0D47A1', light: '#E3F2FD', mid: '#BBDEFB', white: '#FFFFFF', body: '#374151', muted: '#90A4AE', headerText: '#FFFFFF', titleText: '#1565C0', rule: null, ..._colored },
  emerald:  { primary: '#2E7D32', grad: '#43A047', dark: '#1B5E20', light: '#E8F5E9', mid: '#C8E6C9', white: '#FFFFFF', body: '#374151', muted: '#90A4AE', headerText: '#FFFFFF', titleText: '#2E7D32', rule: null, ..._colored },
  charcoal: { primary: '#37474F', grad: '#546E7A', dark: '#263238', light: '#ECEFF1', mid: '#CFD8DC', white: '#FFFFFF', body: '#374151', muted: '#90A4AE', headerText: '#FFFFFF', titleText: '#37474F', rule: null, ..._colored },
  maroon:   { primary: '#880E4F', grad: '#AD1457', dark: '#560027', light: '#FCE4EC', mid: '#F48FB1', white: '#FFFFFF', body: '#374151', muted: '#90A4AE', headerText: '#FFFFFF', titleText: '#880E4F', rule: null, ..._colored },
  plain:    { primary: '#1A1A1A', grad: '#444444', dark: '#000000', light: '#F5F5F5', mid: '#D9D9D9', white: '#FFFFFF', body: '#1A1A1A', muted: '#888888', headerText: '#FFFFFF', titleText: '#1A1A1A', rule: null, ..._colored },
  minimal:  { primary: '#FFFFFF', grad: '#000000', dark: '#FFFFFF', light: '#FFFFFF', mid: '#FFFFFF', white: '#FFFFFF', body: '#000000', muted: '#000000', headerText: '#000000', titleText: '#000000', rule: '#000000',
    statusGreen:  '#000000', statusRed:    '#000000', statusAmber:  '#000000',
    borderMid:    '#000000', borderLight:  '#000000', borderDark:   '#000000',
    rowAlt:       '#FFFFFF', sectionBg:    '#FFFFFF', subtotalBg:   '#FFFFFF', totalBg: '#FFFFFF',
    textSub:      '#000000', textTertiary: '#000000', textFaint:    '#000000',
  },
};

const DEFAULT_THEME = 'navy';

export { PDF_THEMES, DEFAULT_THEME };
